module.exports = "input {\n  width: 63px;\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/spk/inputs/spk-quantity/spk-quantity.component.scss
// module id = ./src/app/components/framework/spk/inputs/spk-quantity/spk-quantity.component.scss
// module chunks = main